export const GET_QUESTIONS_API_HTTP_STATUS_CODES = [
  403, 404, 422, 500, 503, 504,
];

export const ADD_QUESTION_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const UPDATE_QUESTION_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const REMOVE_QUESTION_API_HTTP_STATUS_CODES = [
  400, 403, 404, 422, 500, 503, 504,
];

export const GET_QUESTIONS_ERROR_MESSAGE =
  "Error in getting questions, please try again.";

export const ADD_QUESTION_ERROR_MESSAGE =
  "Error in adding question, please try again.";

export const UPDATE_QUESTION_ERROR_MESSAGE =
  "Error in updating question, please try again.";

export const REMOVE_QUESTION_ERROR_MESSAGE =
  "Error in removing question, please try again.";
